<developer-helper [datasourceCode]="OldDataSourceCode.UNKNOWN" />
<data-viz-widget-spawner
    [dataSources]="dataSources"
    [customInputs]="customInputs$ | async"
    [ghostComponent]="ghostComponent$ | async"
    [ghostConfig]="ghostConfig$ | async"
    [shellComponent]="shellComponent$ | async"
    [shellConfig]="shellConfig$ | async"
/>
